"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitChatClient = useInitChatClient;
var _lodash = require("lodash");
var _react = require("react");
var _streamChat = require("stream-chat");
var _ = require("./..");
var _shared = require("../../shared");
var _excluded = ["type"];
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var chatStateReducer = function chatStateReducer(state, action) {
  var type = action.type,
    otherProps = _objectWithoutProperties(action, _excluded);
  var getAttemptProps = function getAttemptProps(message) {
    var attemptNumber = (state.attemptNumber || 0) + 1;
    var extra = attemptNumber && attemptNumber > 1 && "Attempt #".concat(attemptNumber, ".");
    return {
      attemptNumber: attemptNumber,
      message: (0, _lodash.compact)([message, extra]).join(' ')
    };
  };
  switch (type) {
    case _.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_ATTEMPT:
      return _objectSpread(_objectSpread({}, otherProps), {}, {
        code: type
      }, getAttemptProps('Loading chat...'));
    case _.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_FAILED:
      return _objectSpread(_objectSpread({}, otherProps), {}, {
        code: type,
        message: 'Unable to load chat.',
        callback: action.refetch,
        actionText: 'Reload chat'
      });
    case _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_ATTEMPT:
      return _objectSpread(_objectSpread({}, otherProps), {}, {
        code: type
      }, getAttemptProps('Initializing chat...'));
    case _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_FAILED:
      return _objectSpread(_objectSpread({}, otherProps), {}, {
        code: type,
        message: 'Unable to initialize chat.',
        callback: action.refetch,
        actionText: 'Reload chat'
      });
    case _.CHAT_STATE_ACTIONS.CHANNELS_INITIALIZATION_ATTEMPT:
      return _objectSpread(_objectSpread({}, otherProps), {}, {
        code: type
      }, getAttemptProps('Loading chats...'));
    case _.CHAT_STATE_ACTIONS.CHANNELS_INITIALIZATION_FAILED:
      return _objectSpread(_objectSpread({}, otherProps), {}, {
        code: type,
        message: 'Unable to load chats.',
        callback: action.refetch,
        actionText: 'Reload chat'
      });
    case _.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_DONE:
    case _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_DONE:
    case _.CHAT_STATE_ACTIONS.CHANNELS_INITIALIZATION_DONE:
    default:
      return {};
  }
};
var useChatCredentials = function useChatCredentials(isAuthenticated, dispatch) {
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    refetch = _useState2[0],
    setRefetch = _useState2[1];
  var _useFetchWithRetry = (0, _.useFetchWithRetry)((0, _.getChatCredentialsUrl)(), {}, isAuthenticated, true, (0, _react.useCallback)(function () {
      dispatch({
        type: _.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_DONE
      });
    }, []), undefined, (0, _react.useCallback)(function (error) {
      dispatch({
        error: error,
        type: _.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_FAILED,
        refetch: refetch
      });
    }, [refetch])),
    attemptNumber = _useFetchWithRetry.attemptNumber,
    data = _useFetchWithRetry.data,
    loading = _useFetchWithRetry.loading,
    credentialsRefetch = _useFetchWithRetry.refetch;
  (0, _react.useEffect)(function () {
    setRefetch(function () {
      return credentialsRefetch;
    });
  }, [credentialsRefetch]);
  var _ref = data || {},
    apiKey = _ref.apiKey,
    token = _ref.token;
  (0, _react.useEffect)(function () {
    if (attemptNumber > 0) {
      dispatch({
        type: _.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_ATTEMPT
      });
    }
  }, [attemptNumber, dispatch]);
  return {
    apiKey: apiKey,
    loading: loading,
    refetch: refetch,
    token: token
  };
};
function useInitChatClient(_ref2) {
  var _ref2$user = _ref2.user,
    user = _ref2$user === void 0 ? {} : _ref2$user,
    _ref2$isAuthenticated = _ref2.isAuthenticated,
    isAuthenticated = _ref2$isAuthenticated === void 0 ? false : _ref2$isAuthenticated,
    initData = _ref2.initData;
  var _useState3 = (0, _react.useState)(initData),
    _useState4 = _slicedToArray(_useState3, 2),
    client = _useState4[0],
    setClient = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    chatUser = _useState6[0],
    setChatUser = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loadingChat = _useState8[0],
    setLoadingChat = _useState8[1];
  var _useReducer = (0, _react.useReducer)(chatStateReducer, {}),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    chatState = _useReducer2[0],
    dispatchChatAction = _useReducer2[1];
  var _useChatCredentials = useChatCredentials(isAuthenticated, dispatchChatAction),
    apiKey = _useChatCredentials.apiKey,
    token = _useChatCredentials.token;
  (0, _react.useEffect)(function () {
    if ([_.CHAT_STATE_ACTIONS.CREDENTIALS_LOADING_FAILED, _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_FAILED, _.CHAT_STATE_ACTIONS.CHANNELS_INITIALIZATION_FAILED].includes(chatState.code)) {
      var _chatState$error;
      (0, _shared.trackUserEvent)({
        eventName: 'Getstream Chat Error',
        eventValues: {
          error: (0, _.stringifyError)(chatState.error),
          message: (_chatState$error = chatState.error) === null || _chatState$error === void 0 ? void 0 : _chatState$error.message
        }
      });
    }
  }, [chatState]);
  var _useState9 = (0, _react.useState)(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    isClientInitialized = _useState10[0],
    setIsClientInitialized = _useState10[1];
  var _useMemo = (0, _react.useMemo)(function () {
      var chatClient;
      var initClient = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _ref4, firstName, lastName, image, nickName, fullName, userData, currentChatUser;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _ref4 = (user === null || user === void 0 ? void 0 : user.profile) || {}, firstName = _ref4.firstName, lastName = _ref4.lastName, image = _ref4.image;
                  dispatchChatAction({
                    type: _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_ATTEMPT
                  });
                  setLoadingChat(true);
                  chatClient = new _streamChat.StreamChat(apiKey, {
                    timeout: 0
                  });
                  nickName = user.nickName;
                  fullName = (0, _.composeName)([firstName, lastName], ' ');
                  _context.prev = 6;
                  userData = {
                    id: user.accountId,
                    name: (0, _.isPatient)(user) ? nickName : fullName,
                    // next fields are custom data
                    applicationRole: user.roles,
                    nickName: nickName,
                    firstName: (0, _.isPatient)(user) ? null : firstName,
                    lastName: (0, _.isPatient)(user) ? null : lastName,
                    fullName: (0, _.isPatient)(user) ? null : fullName,
                    image: (0, _.isClinician)(user) ? image : null
                  };
                  _context.next = 10;
                  return chatClient.connectUser(userData, token);
                case 10:
                  currentChatUser = _context.sent;
                  setChatUser(currentChatUser);
                  setClient(chatClient);
                  setIsClientInitialized(true);
                  dispatchChatAction({
                    type: _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_DONE
                  });
                  _context.next = 21;
                  break;
                case 17:
                  _context.prev = 17;
                  _context.t0 = _context["catch"](6);
                  console.error(_context.t0);
                  throw _context.t0;
                case 21:
                  _context.prev = 21;
                  setLoadingChat(false);
                  return _context.finish(21);
                case 24:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[6, 17, 21, 24]]);
        }));
        return function initClient() {
          return _ref3.apply(this, arguments);
        };
      }();
      return [initClient];
    }, [apiKey, token, user]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    initChat = _useMemo2[0],
    destroyChat = _useMemo2[1];
  (0, _react.useEffect)(function () {
    if (apiKey && token && !!user && isClientInitialized === undefined) {
      var catchChatInitError = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(promise) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  promise.catch(function (error) {
                    dispatchChatAction({
                      error: error,
                      type: _.CHAT_STATE_ACTIONS.CLIENT_INITIALIZATION_FAILED,
                      refetch: function () {
                        var _refetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                          return regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return catchChatInitError(initChat());
                                case 2:
                                  return _context2.abrupt("return", _context2.sent);
                                case 3:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));
                        function refetch() {
                          return _refetch.apply(this, arguments);
                        }
                        return refetch;
                      }()
                    });
                  });
                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function catchChatInitError(_x) {
          return _ref5.apply(this, arguments);
        };
      }();
      catchChatInitError((0, _.retry)(function () {
        return initChat();
      }));
    }
    return destroyChat;
  }, [apiKey, destroyChat, initChat, token, user, isClientInitialized]);
  return {
    chatState: chatState,
    client: client,
    dispatchChatAction: dispatchChatAction,
    loadingChat: loadingChat,
    chatUser: chatUser
  };
}